export const countries = [
  { id: 'AR', name: 'Argentina' },
  { id: 'BR', name: 'Brasil' },
  { id: 'CL', name: 'Chile' },
  { id: 'UY', name: 'Uruguay' },
  { id: 'PY', name: 'Paraguay' },
  { id: 'BO', name: 'Bolivia' },
  { id: 'PE', name: 'Perú' },
  { id: 'CO', name: 'Colombia' },
  { id: 'MX', name: 'México' },
  { id: 'ES', name: 'España' },
  { id: 'US', name: 'Estados Unidos' },
  { id: 'IT', name: 'Italia' },
  { id: 'DE', name: 'Alemania' },
  { id: 'FR', name: 'Francia' },
  { id: 'UK', name: 'Reino Unido' },
];
